import React, { PureComponent } from 'react';

import TarjetaHeader from "./TarjetaHeader";
import TarjetaItem from "./TarjetaItem";
import TarjetaFooter from "./TarjetaFooter";

class Tarjeta extends PureComponent {
    constructor(props) {
        super(props)

        this.state = {
            toggleClass: "",
            maxHeightSibling: null,
            index: props.index
        }

        this.toggleAcordeon = this.toggleAcordeon.bind(this);
    }

    toggleAcordeon(event) {
        let divTarjetas = document.getElementById("tarjeta-cc-acor" + this.state.index);
        let toggleClass = ((this.state.toggleClass == "") ? "active" : "");
        let maxHeightSibling = this.state.maxHeightSibling;

        if (maxHeightSibling) {
            maxHeightSibling = null;
        } else {
            //maxHeightSibling = divTarjetas.style.maxHeight + (divTarjetas.scrollHeight + 20) + "px";
            maxHeightSibling = divTarjetas.style.maxHeight + (divTarjetas.scrollHeight) + "px";
        }

        this.setState({ toggleClass, maxHeightSibling });
    }

    render() {

        let component = null;
        let componentExt = null;
        const { consumosTarjetas, extension, index, montoTotales } = this.props;

        return (
            <div className="row no-margin fondo-gris">
                <TarjetaHeader data={extension} index={index} toggleClass={this.state.toggleClass}
                    onToggleAcordeon={this.toggleAcordeon} />

                <div id={"tarjeta-cc-acor" + index}
                    className={"panel-sub-acordeon " + this.state.toggleClass}
                    style={{ maxHeight: this.state.maxHeightSibling }}>
                    {/*iterar por cada detalle de la tarjeta*/}
                    {consumosTarjetas.map((cont, index) => {
                        return <TarjetaItem data={cont} key={index} i={index} />
                    })}
                    {/*fin iteracion*/}
                </div>
                <div>
                    <TarjetaFooter data={consumosTarjetas.filter(x => x.TarjetaCreditoId == extension.Id)} montoTotales={montoTotales} />
                </div>
            </div>
        );
    }
}


export default Tarjeta;